<template>
  <div>
    <base-title
      :title="'Expirados e pausados'"
      :subtitle="StringLanguage.coupons"
      :link="'cupons'"
    />

    <div class="row mb_30">
      <div
        v-for="coupon in couponsExpired"
        :key="coupon.code"
        class="col-lg-4 col-md-6 col-xs-12"
      >
        <coupons-card
          :coupon="coupon"
          :expired="true"
          @onFinishReactivation="refreshCouponsLoad"
        />
      </div>
    </div>

    <base-empty
      v-if="couponsExpired.length == 0"
      title="Você ainda não tem cupons expirados"
      message="Todos os seus cupons expirados irão aparecer por aqui."
    />

    <infinite-loading
      spinner="wavedots"
      ref="infiniteLoading"
      @infinite="infiniteHandler"
    >
      <div slot="no-more"></div>
      <div slot="no-results"></div>
    </infinite-loading>
  </div>
</template>
<script>
import BaseTitle from '@/components/Title';
import BaseEmpty from '@/components/Empty';
import CouponsCard from '@/containers/Coupons/CouponsCard';

import GiftAPI from '@/api/coupon';

import InfiniteLoading from 'vue-infinite-loading';

export default {
  data() {
    return {
      page: 1,
      couponsExpired: [],
    };
  },
  methods: {
    getCoupons(page = 1, limit = 12) {
      return GiftAPI.list(true, null, page, limit).then((response) => {
        const coupons = response.getData([]);

        page === 1
          ? (this.couponsExpired = coupons)
          : this.couponsExpired.push(...coupons);

        return coupons.length > 0;
      });
    },
    async infiniteHandler($state) {
      const result = await this.getCoupons(this.page);
      if (result) {
        this.page++;
        $state.loaded();
      } else {
        $state.complete();
      }
    },
    refreshCouponsLoad() {
      this.page = 1;
      this.couponsExpired = [];
      this.$refs.infiniteLoading.stateChanger.reset();
    },
  },
  computed: {},
  components: {
    BaseTitle,
    BaseEmpty,
    CouponsCard,
    InfiniteLoading,
  },
};
</script>
<style scoped></style>
